import React, { useEffect } from 'react'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import { useSignatureForm } from './hooks/useSignatureForm'
import CompanySelector from './Components/CompanySelector'
import CreditsSection from './Components/CreditsSection'
import ConnectionsSection from './Components/ConnectionsSection'
import AlertsSection from './Components/AlertsSection'
import CancelConfirmationModal from './Components/CancelConfirmationModal'

export default function Create() {
    const params = useParams<{ app_name: string }>()
    const history = useHistory()
    const location = useLocation()

    // Récupérer les query params
    const queryParams = new URLSearchParams(location.search)
    const id_plaque = queryParams.get('id_plaque')


    const {
        // State global
        loading,
        showCancelModal,
        setShowCancelModal,
        companies,
        users,
        selectedCompany,
        setSelectedCompany,

        contreSignatureAutomatique,
        setContreSignatureAutomatique,

        // Actions globales
        handleSave,
        handleCancel,
        confirmCancel,

        // Hooks spécifiques
        creditsHook,
        connectionsHook,
        alertsHook,
        relancesHook,
    } = useSignatureForm(params.app_name, history)

    // Auto-sélection de la société depuis l'URL
    useEffect(() => {
        if (id_plaque && companies.length > 0 && !selectedCompany) {
            const company = companies.find(c => c.IDPlaque === parseInt(id_plaque))
            if (company) setSelectedCompany(company)
        }
    }, [id_plaque, companies, selectedCompany, setSelectedCompany])

    // Affichage du loader
    if (loading) {
        return (
            <div className="container-fluid">
                <div className="text-center mt-5">
                    <i className="fa fa-spinner fa-spin fa-3x"></i>
                    <p>Chargement...</p>
                </div>
            </div>
        )
    }

    // Rendu principal
    return (
        <div className="container-fluid mb-5">
            <div className="row">
                <div className="col">
                    {/* Header avec boutons */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h2>Oodrive : signature électronique</h2>
                        <div>
                            <button onClick={handleCancel} className="btn btn-secondary mr-2">
                                Annuler
                            </button>
                            <button onClick={handleSave} className="btn btn-success">
                                Enregistrer
                            </button>
                        </div>
                    </div>

                    {/* Company selection */}
                    <CompanySelector
                        companies={companies}
                        selectedCompany={selectedCompany}
                        onCompanyChange={setSelectedCompany}
                    />

                    {selectedCompany && (
                        <>
                            {/* Credits Management */}
                            <CreditsSection {...creditsHook} />

                            {/* Contre-signature */}
                            <div className="card mb-4">
                                <div className="card-header">
                                    <h5 className="mb-0">Contre-signature automatique</h5>
                                </div>
                                <div className="card-body">
                                    <div className="d-flex align-items-center">
                                        <button
                                            type="button"
                                            title="Si désactivée, chaque document devra être contre-signé manuellement depuis l'interface Oodrive."
                                            className={`btn btn-sm ${contreSignatureAutomatique ? 'btn-success' : 'btn-warning'}`}
                                            onClick={() => setContreSignatureAutomatique(!contreSignatureAutomatique)}
                                        >
                                            <i className={`fa ${contreSignatureAutomatique ? 'fa-toggle-on' : 'fa-toggle-off'} mr-1`}></i>
                                            {contreSignatureAutomatique ? 'Activée' : 'Désactivée'}
                                        </button>
                                        <span className="ml-3 text-muted small">
                                            Si activée, les documents sont contre-signés automatiquement une fois signés par le client.
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Connections */}
                            <ConnectionsSection
                                {...connectionsHook}
                                sites={selectedCompany.Sites}
                                users={users}
                                appName={params.app_name}
                            />

                            {/* Alerts and Reminders */}
                            <AlertsSection
                                alertsHook={alertsHook}
                                relancesHook={relancesHook}
                                users={users}
                            />

                            {/* Bottom buttons */}
                            <div className="d-flex justify-content-end mb-4">
                                <button onClick={handleCancel} className="btn btn-secondary mr-2">
                                    Annuler
                                </button>
                                <button onClick={handleSave} className="btn btn-success">
                                    Enregistrer
                                </button>
                            </div>
                        </>
                    )}

                    {/* Cancel Modal */}
                    <CancelConfirmationModal
                        isOpen={showCancelModal}
                        onCancel={confirmCancel}
                        onContinue={() => setShowCancelModal(false)}
                    />
                </div>
            </div>
        </div>
    )
}
